import axios from "axios";
import queryString from "query-string";
import {getApiUrlBrandName} from "./public_functions";

const params = queryString.parse(window.location.search);
let domain = params["domain"];
let nextrades_api_url = "https://nextrades.ai";

const getParams = (paramsData) => {
    let params = "";
    Object.keys(paramsData).map((key, index) => {
        let param = "";
        if (index !== 0) {
            param += `&`;
        }
        param += `${key}=${encodeURIComponent(paramsData[key])}`;
        return (params += param);
    });
    return params;
};

export const BrandSettingsAPI = async () => {
    let oldAdminPanel = getApiUrlBrandName(domain).oldAdminPanel;
    let apiUrl = getApiUrlBrandName(domain).apiUrl;
    let API = oldAdminPanel ? `${apiUrl}/user-api/data/brand-settings` : apiUrl;
    let data = "";
    const headers = {
        "content-type": "application/json",
    };
    if (!oldAdminPanel) {
        const graphqlQuery = {
            operationName: "getUserBrandSetting",
            query: `query getUserBrandSetting { 
              getUserBrandSetting {
                ... on UserBrandSetting {
                  companyLogo
                  companyLogoSmall
                  companyName
                  companyNameShort
                }
              } 
            }`,
            variables: {},
        };
        data = graphqlQuery;
    }
    return await axios({url: API, method: "POST", headers, data: data})
        .then((response) => {
            if (response.status === 200) {
                return response.data;
            }
        })
        .catch((error) => console.log(error));
};

export const RegistrationModuleAPI = async () => {
    let apiUrl = getApiUrlBrandName(domain).apiUrl;
    let API = apiUrl;
    let data = "";
    const headers = {
        "content-type": "application/json",
    };
    const graphqlQuery = {
        operationName: "getRegistrationModule",
        query: `query getRegistrationModule { 
              getRegistrationModule {
                ... on RegistrationModule {
                    liveRegistration
                    demoRegistration
                }
              } 
            }`,
        variables: {},
    };
    data = graphqlQuery;
    return await axios({url: API, method: "POST", headers, data: data})
        .then((response) => {
            if (response.status === 200) {
                return response.data;
            }
        })
        .catch((error) => console.log(error));
};

export const EconomicCalendarAPI = async (filters) => {
    let API = `${nextrades_api_url}/tc-e/economic-calendar?${getParams(filters)}`;
    return await axios(API)
        .then((response) => {
            if (response.status === 200) {
                return response.data;
            }
        })
        .catch((error) => console.log(error));
};

export const EventChartDataAPI = async (data) => {
    let API = `${nextrades_api_url}/user-api/data/economic-calendar-event-chart?${getParams(data)}`;
    return await axios(API)
        .then((response) => {
            if (response.status === 200) {
                return response.data;
            }
        })
        .catch((error) => console.log(error));
};

export const CurrencySymbolDataAPI = async (data) => {
    let API = `${nextrades_api_url}/user-api/data/economic-calendar-currency-symbol?${getParams(data)}`;
    return await axios(API)
        .then((response) => {
            if (response.status === 200) {
                return response.data;
            }
        })
        .catch((error) => console.log(error));
};
